import { api } from './client';
import { ROUTES } from './routes';

/**
 * Envia evento de observabilidade para o backend.
 * Fire-and-forget — não bloqueia o fluxo do usuário.
 */
export function trackEvent(data: {
  source: string;
  action: string;
  targetId?: string;
  targetType?: string;
  metadata?: Record<string, any>;
}) {
  try {
    void api.post(ROUTES.observe.track, data).catch(() => {
      // silently fail — observability should never break UX
    });
  } catch {
    /* ignore */
  }
}
